module.exports = __webpack_public_path__ + "static/media/400390_02.c1368d12.png";